module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-3f388b7a24f2e622aa4dae31ea02b2ac.png";